/**
 * ILO rebuild trigger - the dashboard's one write into the clustering
 * pipeline. Backs the GenerationPicker's "New topic generation" control:
 * an admin launches a fresh clustering generation and pins it once it
 * completes.
 *
 * Bisecting is the only algorithm a manual pass can request; the server
 * rejects any other value. The pass runs with the server-configured
 * defaults. (History can still list older algorithms, and low-data
 * tenants get flat kmeans generations chosen by the backend, but neither
 * is requestable from here.)
 *
 * Enum encoding follows the dashboard-wide rule: proto enums go on the
 * wire as their full constant-name string (grpc-gateway JSON), NOT the
 * short lowercase form the analytics graph returns. See the analytics
 * list in GenerationPicker.jsx for the read-side short names.
 */
import { restPost } from "./restClient.js";

const REBUILD_PATH = "/v1/ilo/rebuilds";

// Short lowercase name - the same token the analytics generation list and
// the filter chips use, so a launched pass can select its own chip.
export const REBUILD_ALGORITHM = "bisecting";
const REBUILD_ALGORITHM_PROTO = "CLUSTERING_ALGORITHM_BISECTING";

/**
 * Build the TriggerIloRebuildRequest body. Pure - no network.
 *
 * Only ever sets `algorithm`, so every launch takes the server-config
 * defaults.
 */
export function buildRebuildRequest() {
    return { algorithm: REBUILD_ALGORITHM_PROTO };
}

/**
 * Launch a bisecting clustering pass. Resolves to the gateway response
 * ({ rebuildId } - a base64 generation id) or throws with the server's
 * human message on `err.serverMessage`.
 */
export function triggerIloRebuild() {
    return restPost(REBUILD_PATH, buildRebuildRequest());
}
